module.exports = __webpack_public_path__ + "img/doar-large.792f95dc.svg";